import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const articles = [
  {
    category: "皮膚修復",
    title: "認識妊娠紋：成因、黃金修復期與日常護理",
    excerpt: "妊娠紋的形成與膠原蛋白斷裂息息相關，掌握黃金修復期，配合正確護理，能顯著改善紋路外觀與肌膚彈性。",
    date: "2026-09-05",
    img: "https://readdy.ai/api/search-image?query=Close-up%20of%20smooth%20healthy%20lower%20abdomen%20skin%20after%20professional%20stretch%20mark%20treatment%2C%20soft%20warm%20natural%20light%2C%20clean%20cream%20background%2C%20professional%20medical%20aesthetic%20editorial%20photography&width=800&height=500&seq=ishb-article-1&orientation=landscape",
  },
  {
    category: "疤痕重建",
    title: "非手術疤痕修復：海洋生物製劑如何安全地重塑肌膚",
    excerpt: "相比傳統手術，非手術疤痕修復以海洋生物製劑為主，強調安全性，連孕婦與幼兒也可安心使用。",
    date: "2026-08-28",
    img: "https://readdy.ai/api/search-image?query=Professional%20clinical%20dermatology%20treatment%20scene%20with%20gentle%20hands%20applying%20marine%20biological%20serum%20to%20skin%2C%20soft%20natural%20light%2C%20warm%20cream%20tones%2C%20editorial%20medical%20aesthetic%20photography&width=800&height=500&seq=ishb-article-2&orientation=landscape",
  },
  {
    category: "逆齡抗衰老",
    title: "逆齡抗衰老：從肌底重建膠原的科學原理",
    excerpt: "了解皮膚老化的根本原因，透過離子紅光技術與深層修復，激活肌膚自身再生能力，重現年輕光采。",
    date: "2026-08-20",
    img: "https://readdy.ai/api/search-image?query=Elegant%20woman%20face%20with%20radiant%20youthful%20glowing%20skin%20receiving%20professional%20anti-aging%20red%20light%20therapy%20treatment%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20editorial%20medical%20aesthetic%20photography&width=800&height=500&seq=ishb-article-3&orientation=landscape",
  },
  {
    category: "產後修復",
    title: "AI 產後修復：科技如何幫助新手媽媽重拾自信",
    excerpt: "AI 超離子皮膚技術結合產後修復，針對鬆弛、紋路與疲憊肌，提供更精準、更舒適的修復體驗。",
    date: "2026-08-12",
    img: "https://readdy.ai/api/search-image?query=Gentle%20mother%20holding%20newborn%20baby%20in%20warm%20bright%20nursery%2C%20soft%20natural%20sunlight%2C%20calm%20soothing%20atmosphere%2C%20cream%20and%20soft%20green%20tones%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=ishb-article-4&orientation=landscape",
  },
  {
    category: "眼部年輕化",
    title: "童顏眼瞼：安全有效的眼部年輕化之道",
    excerpt: "眼部肌膚最為脆弱，童顏眼瞼技術針對眼袋、細紋與鬆弛，以非侵入方式重現明亮有神的雙眸。",
    date: "2026-08-05",
    img: "https://readdy.ai/api/search-image?query=Close-up%20of%20beautiful%20bright%20youthful%20eyes%20of%20an%20asian%20woman%20with%20smooth%20eyelid%20skin%2C%20natural%20makeup%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20professional%20editorial%20beauty%20photography&width=800&height=500&seq=ishb-article-5&orientation=landscape",
  },
  {
    category: "肌膚健康",
    title: "日常肌膚保養五大誤區，你中了幾個？",
    excerpt: "過度清潔、忽視防曬、頻繁更換產品……這些常見的保養迷思，可能正悄悄傷害你的肌膚屏障。",
    date: "2026-07-30",
    img: "https://readdy.ai/api/search-image?query=Minimalist%20skincare%20products%20arranged%20on%20clean%20cream%20table%20with%20natural%20light%2C%20gentle%20botanical%20elements%2C%20soft%20shadows%2C%20editorial%20product%20photography&width=800&height=500&seq=ishb-article-6&orientation=landscape",
  },
];

const categories = ["全部", "皮膚修復", "疤痕重建", "逆齡抗衰老", "產後修復", "眼部年輕化", "肌膚健康"];

export default function Articles() {
  const [active, setActive] = useState("全部");

  const filtered = active === "全部" ? articles : articles.filter((a) => a.category === active);

  return (
    <div className="min-h-screen bg-white text-brand-900">
      <Navbar />

      <section className="pt-32 md:pt-40 pb-16 md:pb-20 bg-brand-50/60">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="inline-block px-6 py-2 rounded-md bg-brand-600 text-white text-lg tracking-wider">專業文章</div>
          <h1 className="mt-6 font-serif text-3xl md:text-5xl text-brand-800">肌膚健康與美業知識</h1>
          <p className="mt-4 text-brand-700/70 max-w-2xl text-sm md:text-base">
            由 ISHB 專業團隊撰寫，分享皮膚修復、疤痕重建、逆齡抗衰老與產後修復等實用知識，助你更了解自己的肌膚。
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition border ${
                  active === c
                    ? "bg-brand-600 text-white border-brand-600"
                    : "bg-white text-brand-700 border-brand-200 hover:bg-brand-50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((a) => (
              <article key={a.title} className="rounded-xl overflow-hidden bg-white border border-brand-100 hover:border-brand-200 transition cursor-pointer">
                <div className="relative h-48 overflow-hidden">
                  <img src={a.img} alt={a.title} className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105" />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/90 text-xs font-medium text-brand-700 whitespace-nowrap">
                    {a.category}
                  </span>
                </div>
                <div className="p-5">
                  <time className="text-xs text-brand-700/50">{a.date}</time>
                  <h3 className="mt-2 text-base md:text-lg font-semibold text-brand-800 leading-snug">{a.title}</h3>
                  <p className="mt-3 text-sm text-brand-700/70 leading-relaxed line-clamp-3">{a.excerpt}</p>
                  <div className="mt-4 flex items-center gap-1.5 text-sm text-brand-600">
                    閱讀全文 <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}